export default __webpack_public_path__ + "static/media/MACS-Logo.5706b386.svg";